import * as THREE from "three";

class ScreenCoordinateHelper{
  static GetScale(camera:(THREE.PerspectiveCamera|THREE.OrthographicCamera), height:number){
    if(camera instanceof THREE.PerspectiveCamera)
      {
          let halfAngle = (camera.fov * 0.5) * (Math.PI / 180)
          let L = Math.tan(halfAngle) * camera.position.z * 2
          let P = height;
          let P2 = L / P
          let minDis = P2
          return minDis;
      }
      else
      {
          return (camera.top - camera.bottom) / height;
      }
    }
}

export {ScreenCoordinateHelper}